import { AIUIModel } from "src/store/models/ui/ai/ai";
import { AITableUIModel } from "src/store/models/ui/ai/aiTable";
import { ServiceStatisticsUIModel } from "src/store/models/ui/ai/serviceStatistics";

export const encooAIUIModels = {
  AI: AIUIModel,
  AITable: AITableUIModel,
  ServiceStatistics: ServiceStatisticsUIModel,
};
